import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public pendingRequestsCount: number = 0
  public finalRequestsCount: number = 0
  
  // Add routes that should not show the loading indicator
  private disabledRoutes: string[] = [
    '/pipe-line',
    '/dashboardsale-detail'
    // Add other routes as needed
  ];
  
  private currentRoute: string = '';

  constructor(private router: Router) {
    // Track current route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.url;
    });
  }
  
  // Check if loading should be disabled for current route
  public get isLoadingDisabled(): boolean {
    return this.disabledRoutes.some(route => 
      this.currentRoute.startsWith(route));
  }
  
  // Use this method instead of directly setting isLoading
  public setLoading(isLoading: boolean): void {
    if (this.isLoadingDisabled) {
      this.isLoading.next(false);
    } else {
      this.isLoading.next(isLoading);
    }
  }
}
